<div class="grid gap-6 lg:grid-cols-[1.1fr_0.9fr]">
    <mat-card class="rounded-lg border border-slate-200 p-6 shadow-sm">
        <mat-card-header class="mb-6">
            <mat-card-title class="text-2xl font-semibold text-slate-900">Create user</mat-card-title>
            <mat-card-subtitle>Add a new managed user with email and password credentials.</mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
            <form class="grid gap-4" [formGroup]="registerForm" (ngSubmit)="submit()">
                <mat-form-field appearance="outline">
                    <mat-label>First name</mat-label>
                    <input matInput type="text" formControlName="firstName">
                    @if (registerForm.controls.firstName.invalid && registerForm.controls.firstName.touched) {
                        <mat-error>First name is required.</mat-error>
                    }
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>Last name</mat-label>
                    <input matInput type="text" formControlName="lastName">
                    @if (registerForm.controls.lastName.invalid && registerForm.controls.lastName.touched) {
                        <mat-error>Last name is required.</mat-error>
                    }
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>Email</mat-label>
                    <input matInput type="email" formControlName="email">
                    @if (registerForm.controls.email.invalid && registerForm.controls.email.touched) {
                        <mat-error>Enter a valid email address.</mat-error>
                    }
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>Password</mat-label>
                    <input matInput type="password" formControlName="password">
                    @if (registerForm.controls.password.invalid && registerForm.controls.password.touched) {
                        <mat-error>Password must be at least 8 characters.</mat-error>
                    }
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>Portal *</mat-label>
                    <mat-select formControlName="portalId">
                        <mat-option value="">Select portal</mat-option>
                        @for (item of portals(); track item.id) {
                            <mat-option [value]="item.id">{{ item.name }}</mat-option>
                        }
                    </mat-select>
                    @if (registerForm.controls.portalId.invalid && registerForm.controls.portalId.touched) {
                        <mat-error>Portal is required.</mat-error>
                    }
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>User role *</mat-label>
                    <mat-select formControlName="userRoleId">
                        <mat-option value="">Select user role</mat-option>
                        @for (item of userRoles(); track item.id) {
                            <mat-option [value]="item.id">{{ item.name }}</mat-option>
                        }
                    </mat-select>
                    @if (registerForm.controls.userRoleId.invalid && registerForm.controls.userRoleId.touched) {
                        <mat-error>User role is required.</mat-error>
                    }
                </mat-form-field>

                @if (isClientPortal()) {
                    <mat-form-field appearance="outline">
                        <mat-label>Client</mat-label>
                        <mat-select formControlName="clientId">
                            <mat-option value="">No client</mat-option>
                            @for (item of clients(); track item.id) {
                                <mat-option [value]="item.id">{{ item.name }}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                }

                @if (isAffiliatePortal()) {
                    <searchable-lookup-select
                        [formControl]="registerForm.controls.affiliateId"
                        label="Affiliate"
                        placeholder="No affiliate"
                        searchPlaceholder="Search affiliates"
                        loadingLabel="Loading affiliates..."
                        [options]="affiliateOptions()"
                        [loading]="affiliateOptionsLoading()"
                        (searchChanged)="affiliateSearchChanged.emit($event)" />
                }

                <div class="flex justify-end pt-2">
                    <button mat-flat-button type="submit" [disabled]="busy()">
                        @if (busy()) {
                            Saving...
                        } @else {
                            Create user
                        }
                    </button>
                </div>
            </form>
        </mat-card-content>
    </mat-card>

    <app-user-info
        [title]="'Created user'"
        [user]="createdUser()"
    />
</div>

